import FilterCategory from './filterCategory'

export default FilterCategory
